'use client';

import { checkType } from '@/common/ultils';
import React from 'react';
import Image from 'next/image';

const HeaderBanner = ({ headerBanners, deviceType }) => {
  const fileUrl = (headerBanners?.results ?? []).length ? checkType(deviceType, headerBanners?.results?.[0], 0, 'fileUrl', 'sharpMedias') : null;

  return (
    <div className="container mx-auto relative bg-gray-200 overflow-hidden">
      {(headerBanners?.results ?? []).length > 0 && fileUrl && (
        <Image className="w-full h-auto! object-cover position-initial" src={fileUrl} alt={'Ảnh nền banner'} fill priority quality={85} />
        // <img className="w-full h-auto! object-cover" src={fileUrl} alt={'Ảnh nền banner'} />
      )}
    </div>
  );
};

export default HeaderBanner;

